<template>
  <div>
    <CRow>
      <CCol>
        <CCard class="tarjetaCV mt-2">
          <CCardHeader>
            <h4>Logs</h4>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol>
                <CTabs :active-tab.sync="actTab">
                  <CTab>
                    <template slot="title"> Logs </template>
                    <CRow>
                      <CCol md="4">
                        <CSelect
                          size="sm"
                          :options="filtrosTipos"
                          @update:value="seleccionarFiltro"
                          placeholder="Seleccione filtro a consultar"
                        />
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol md="12">
                        <vs-table v-model="selected" striped>
                          <template #header>
                            <vs-input
                              v-model="search"
                              border
                              placeholder="Buscar"
                            />
                          </template>
                          <template #thead>
                            <vs-tr>
                              <vs-th
                                v-for="col in columnasLogs"
                                :style="{ width: col.width }"
                                sort
                                @click="
                                  logsData = $vs.sortData(
                                    $event,
                                    logsData,
                                    col.field
                                  )
                                "
                                v-bind:key="col.field"
                              >
                                {{ col.nombre }}
                              </vs-th>
                            </vs-tr>
                          </template>
                          <template #tbody>
                            <vs-tr
                              :key="i"
                              v-for="(tr, i) in $vs.getPage(
                                $vs.getSearch(logsData, search),
                                page,
                                max
                              )"
                              :data="tr"
                              :is-selected="selected == tr"
                            >
                              <vs-td>
                                {{ tr.userName }}
                              </vs-td>
                              <vs-td>
                                {{ tr.desc }}
                              </vs-td>
                              <vs-td>
                                {{ formatearFecha(tr.fecha) }}
                              </vs-td>
                              <vs-td>
                                <CIcon
                                  v-show="tr.estado"
                                  style="color: green"
                                  name="cil-check-circle"
                                />
                                <CIcon
                                  :alt="tr.estado"
                                  v-show="!tr.estado"
                                  style="color: red"
                                  name="cil-x-circle"
                                />
                              </vs-td>
                              <vs-td>
                                {{ tr.tipo }}
                              </vs-td>
                            </vs-tr>
                          </template>
                          <template v-if="search.length > 0" #notFound>
                            No se encuentran registros para la busqueda
                            {{ search }}
                          </template>
                          <template v-else #notFound>
                            Seleccione un tipo de logs
                          </template>

                          <template #footer>
                            <vs-pagination
                              v-model="page"
                              :length="$vs.getLength(logsData, max)"
                            />
                          </template>
                        </vs-table>
                      </CCol>
                    </CRow>
                  </CTab>
                </CTabs>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
//mport Vue from 'vue'
import cons from "@/const";
import axios from "axios";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

import Multiselect from "vue-multiselect";

import VueModal from "@kouts/vue-modal";
import "@kouts/vue-modal/dist/vue-modal.css";

import { freeSet } from "@coreui/icons";

//import moment from 'moment'
//import { format, formatDistance, formatRelative, subDays } from 'date-fns'
//import es from 'date-fns/locale/es'

import { format, formatDistance, formatRelative, subDays } from "date-fns";

import es from "date-fns/locale/es";
window.locale = "es";

//import DatePicker from 'vue2-datepicker';
//import 'vue2-datepicker/index.css';

export default {
  name: "LogsView",
  freeSet,
  components: {
    Multiselect,
    Modal: VueModal,
    AgGridVue,
  },
  data() {
    return {
      baseUrl: cons.protocolo + "://" + cons.ipServer + cons.puerto,

      tokenLogin: JSON.parse(this.$cookie.get("userLogginTokenAdmin"))
        .tokenUsuario,

      actTab: 0,

      filtroSelected: null,
      filtrosTipos: [
        { value: "PSW", label: "Logs Contraseñas" },
        { value: "INFO", label: "Consulta info" },
        { value: "DSBL", label: "Desbloqueo usuario" },
        { value: "CLS", label: "Cerrar Aplicaciones" },
        { value: "CRT", label: "Creacion clientes" },
      ],

      search: "",
      selected: null,
      page: 1,
      max: 10,
      columnasLogs: [
        { field: "userName", nombre: "Usuario", width: "15%" },
        { field: "desc", nombre: "Descripcion", width: "50%" },
        { field: "fecha", nombre: "Fecha Log", width: "25%" },
        { field: "estado", nombre: "Estado log", width: "10%" },
        { field: "tipo", nombre: "TipoLog", width: "20%" },
      ],
      logsData: [],
    };
  },
  created: function () {},
  beforeMount() {
    //this.getClientes()
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    formatearFecha: function (fecha) {
      /*return formatDistance(new Date(fecha), new Date(), {
        addSuffix: true,
        locale: es,
      }); //.isSame(moment().clone().startOf('day'), 'd')
      */
      return format(new Date(fecha), "EEE d LLL/yyyy H:mm:ss", {
        locale: es,
      });
    },
    seleccionarFiltro: function (filtro) {
      this.filtroSelected = filtro;
      this.getLogs();
    },
    getLogs: function () {
      var url = this.baseUrl + "/get_logs";

      axios({
        method: "POST",
        url: url,
        data: {
          filtro: this.filtroSelected,
        },
        headers: {
          Authorization: this.tokenLogin,
        },
      })
        .then(
          (result) => {
            this.logsData = result.data;
          },
          (error) => {}
        )
        .finally(() => {});
    },
  },
};
</script>

<style>
</style>